import { BaSeParagraph, BaSeSmall2 } from '@base/react';
import React from 'react';
import { Container, ContainerLabel } from './style';

function Input({
  type = 'text',
  value,
  onChange,
  required = false,
  isOptional = false,
  isDisabled = false,
  placeholder = '',
  name = '',
  className = '',
  label = '',
  ...rest
}) {
  return (
    <Container isDisabled={isDisabled}>
      <ContainerLabel>
        {label && <BaSeParagraph color="#0015C1">{label}</BaSeParagraph>}
        {isOptional && <BaSeSmall2 color="#215DF4">(Opcional)</BaSeSmall2>}
      </ContainerLabel>
      <input
        disabled={isDisabled}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        name={name}
        required={required}
        className={className}
        {...rest}
      />
    </Container>
  );
}

export default Input;

// import React, { useState, useEffect } from 'react';
// import { Container, ContainerLabel } from './style';
// import { BaSeParagraph, BaSeSmall2 } from '@base/react';

// function Input({
//   onChange,
//   label,
//   isOptional = false,
//   required = false,
//   debounceTime = 500,
//   className = '',
//   name = '',
//   placeholder = '',
//   ...props
// }) {
//   const [inputValue, setInputValue] = useState(''); // Valor exibido no input
//   const [debouncedValue, setDebouncedValue] = useState(''); // Valor com debounce

//   // Atualiza o valor com debounce após o tempo especificado
//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedValue(inputValue);
//     }, debounceTime);

//     return () => {
//       clearTimeout(handler); // Limpa o timer ao desmontar ou quando `inputValue` muda
//     };
//   }, [inputValue, debounceTime]);

//   // Chama a função de callback (onChange) sempre que o valor com debounce muda
//   useEffect(() => {
//     if (onChange) {
//       onChange(debouncedValue);
//     }
//   }, [debouncedValue, onChange]);

//   return (
//     // <input
//     //   type="text"
//     //   value={inputValue}
//     //   onChange={(e) => setInputValue(e.target.value)}
//     //   {...props} // Permite passar outros props como placeholder, className, etc.
//     // />
//     <Container>
//       <ContainerLabel>
//         {label && <BaSeParagraph color="#0015C1">{label}</BaSeParagraph>}
//         {isOptional && <BaSeSmall2 color="#215DF4">(Opcional)</BaSeSmall2>}
//       </ContainerLabel>
//       <input
//         type="text"
//         value={inputValue}
//         onChange={(e) => setInputValue(e.target.value)}
//         placeholder={placeholder}
//         name={name}
//         required={required}
//         className={className}
//         {...props}
//       />
//     </Container>
//   );
// }

// export default Input;
